import { useGetCommunityQuery } from 'generated/graphql';
import { useCommunityIndicator } from '@client/new/hooks/use-community-indicator';
import auth from '@client/components/auth';

export const useCommunityNotificationsCount = (communityId: string) => {
  const { getLastSeenPostId, isCommunityVisited } = useCommunityIndicator();
  const lastSeenPostId = getLastSeenPostId();
  const communityVisited = isCommunityVisited();
  const isAdminModerator = auth.isAdministrator() || auth.isModerator();

  const { data } = useGetCommunityQuery({
    variables: { id: +communityId },
    skip: isAdminModerator || !lastSeenPostId,
    fetchPolicy: 'network-only',
  });

  if (isAdminModerator) return 0;
  if (!communityVisited) return 1;

  const newerPostsCount = data?.community?.posts
    ?.sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    )
    .findIndex((post) => post.id === lastSeenPostId);

  return newerPostsCount === undefined || newerPostsCount < 0
    ? 0
    : newerPostsCount;
};
